// LiveStreamPusherHandler.js
import { connect } from 'react-redux';

import LiveStreamPusherHandler from '../component/LiveStreamPusherHandler.jsx';
import subscribeStreamChannel from '../action/subscribeStreamChannel.js';
import unsubscribeStreamChannel from '../action/unsubscribeStreamChannel.js';
import subscribeStreamViewerChannel from '../action/subscribeStreamViewerChannel.js';
import unsubscribeStreamViewerChannel from '../action/unsubscribeStreamViewerChannel.js';
import subscribePresenceGoalChannel from '../action/subscribePresenceGoalChannel.js';
import unsubscribePresenceGoalChannel from '../action/unsubscribePresenceGoalChannel.js';

import getLiveStreamData from '../selector/getLiveStreamData.js';
import getMeData from '../selector/getMeData.js';

const mapStateToProps = (state, { streamId }) => {
  const pusherPreset = getLiveStreamData(state, [streamId], 'pusherPreset');
  const meId = getMeData(state, 'id');
  const fundingId = getLiveStreamData(
    state,
    [streamId, 'privateShow'],
    'fundingId'
  );
  return {
    pusherPreset,
    meId,
    fundingId,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    subscribeStreamChannel: data => dispatch(subscribeStreamChannel(data)),
    unsubscribeStreamChannel: data => dispatch(unsubscribeStreamChannel(data)),
    subscribeStreamViewerChannel: data =>
      dispatch(subscribeStreamViewerChannel(data)),
    unsubscribeStreamViewerChannel: data =>
      dispatch(unsubscribeStreamViewerChannel(data)),
    subscribePresenceGoalChannel: data =>
      dispatch(subscribePresenceGoalChannel(data)),
    unsubscribePresenceGoalChannel: data =>
      dispatch(unsubscribePresenceGoalChannel(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamPusherHandler);
